import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal, Button } from './index';
import { api } from '../services/api';

interface RequestSiteModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export function RequestSiteModal({ isOpen, onClose }: RequestSiteModalProps) {
  const { t } = useTranslation();
  const [url, setUrl] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [result, setResult] = useState<{ domain: string; requestCount: number } | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    try {
      new URL(url);
    } catch {
      setError(t('app.requestSiteModal.invalidUrl'));
      return;
    }

    setSubmitting(true);
    try {
      const data = await api.requestSite(url);
      setResult(data);
    } catch {
      setError(t('app.requestSiteModal.failedToSubmit'));
    } finally {
      setSubmitting(false);
    }
  };

  const handleClose = () => {
    setUrl('');
    setError('');
    setResult(null);
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose} title={t('app.requestSiteModal.modalTitle')}>
      {result ? (
        <div className="request-site-success">
          <p>
            {t('app.requestSiteModal.successRequest', { domain: result.domain })}
          </p>
          <p>
            {result.requestCount === 1
              ? t('app.requestSiteModal.successFirst')
              : t('app.requestSiteModal.successCount', { count: result.requestCount })}
          </p>
          <Button onClick={handleClose} style={{ marginTop: 16, width: '100%' }}>
            {t('app.requestSiteModal.doneButton')}
          </Button>
        </div>
      ) : (
        <form className="request-site-form" onSubmit={handleSubmit}>
          <p className="request-site-desc">
            {t('app.requestSiteModal.description')}
          </p>
          <input
            className="input"
            type="url"
            placeholder={t('app.requestSiteModal.placeholder')}
            value={url}
            onChange={(e) => setUrl(e.target.value)}
            required
          />
          {error && <p className="request-site-error">{error}</p>}
          <Button type="submit" disabled={submitting || !url} style={{ width: '100%' }}>
            {submitting ? t('app.requestSiteModal.submitting') : t('app.requestSiteModal.submitButton')}
          </Button>
        </form>
      )}
    </Modal>
  );
}
